var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Icon,{staticClass:"text-lg text-blue-base",class:{ 'text-red-danger': _vm.danger },attrs:{"icon":"material-symbols:thumb-down-rounded"}})
}
var staticRenderFns = []

export { render, staticRenderFns }